import React, { useState, useEffect, useReducer } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import AddIcon from '@material-ui/icons/Add'
import Backdrop from '@material-ui/core/Backdrop'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import CreateIcon from '@material-ui/icons/Create'
import CircularProgress from '@material-ui/core/CircularProgress'
import DeleteIcon from '@material-ui/icons/Delete'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'

import Grid from '@material-ui/core/Grid'
import Fab from '@material-ui/core/Fab'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SearchIcon from '@material-ui/icons/Search'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TablePagination from '@material-ui/core/TablePagination'
import { DropzoneArea } from 'material-ui-dropzone'

import { get, del, postFormData } from '../../config/fetch'
import AlertWrapper from '../common/alert'

const columns = [    
    { id: 'deviceId', disablePadding: false, label: 'DeviceId' },
    { id: 'model', disablePadding: false, label: 'Model' },
    { id: 'brand', disablePadding: false, label: 'brand' },
    { id: 'parameter', disablePadding: false, label: 'Incident' },
    { id: 'createdAt', disablePadding: false, label: 'Date' }
]

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index])
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0])
        if (order !== 0) return order
        return a[1] - b[1]
    })
    return stabilizedThis.map(el => el[0])
}

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    listItem: {
        backgroundColor: theme.palette.background.paper,
        margin: '.5em 0',
    },
    table: {
        width: '100%',
        marginTop: '1em',
    },
    rootList: {
        width: '95%',

        margin: '1em 0',
    },
    wrapperLoader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}))

function DialogCSV(props) {
    const {
        classes,
        handleCloseDialogCsv,
        handleChangeFile,
        stateFile,
        uploadFile,
        visibleDialogCsv,
        setVisibleDialogCsvFormat,
    } = props

    return (
        <Dialog
            open={visibleDialogCsv}
            onClose={handleCloseDialogCsv}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Upload CSV</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    To upload companies from .csv file, please select or drop the file right
                    here.{' '}
                    <span
                        onClick={() => setVisibleDialogCsvFormat(true)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            textDecorationLine: 'underline',
                        }}
                    >
                        View format
                    </span>
                </DialogContentText>
                {stateFile.loading ? (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                ) : (
                    <DropzoneArea
                        filesLimit={1}
                        acceptedFiles={['.csv']}
                        fileObjects={stateFile.file}
                        onChange={files => handleChangeFile(files)}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogCsv} color="primary" disabled={stateFile.loading}>
                    Cancel
                </Button>
                <Button
                    onClick={uploadFile}
                    color="primary"
                    type="submit"
                    disabled={stateFile.loading}
                >
                    Upload
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function DialogCSVFormat(props) {
    const {
        classes,
        handleCloseDialogCsvFormat,
        handleChangeFile,
        stateFile,
        uploadFile,
        visibleDialogCsvFormat,
    } = props

    return (
        <Dialog
            open={visibleDialogCsvFormat}
            onClose={handleCloseDialogCsvFormat}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Format CSV</DialogTitle>
            <DialogContent>
                <div>
                    <img
                        style={{ width: '100%' }}
                        src="https://storageaccountoctol9268.blob.core.windows.net/assets/notificationscreen.png"
                    />
                </div>
                <Box align="center" mt={2}>
                    <a
                        href="https://storageaccountoctol9268.blob.core.windows.net/assets/Base stations Excel.xlsx"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'white' }}
                    >
                        Download Excel file
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a
                        href="https://storageaccountoctol9268.blob.core.windows.net/assets/Base Stations.numbers"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'white' }}
                    >
                        Download Numbers file
                    </a>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleCloseDialogCsvFormat}
                    color="primary"
                    disabled={stateFile.loading}
                >
                    go back
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function DialogDelete(props) {
    const { classes, handleCloseDialogDelete, state, handleDeleteBaseStation, visible } = props

    return (
        <Dialog
            open={visible}
            onClose={handleCloseDialogDelete}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Delete Notification</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure to delete this notification?</DialogContentText>
                {state.loading && (
                    <div className={classes.wrapperLoader}>
                        <CircularProgress />
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialogDelete} color="primary" disabled={state.loading}>
                    Cancel
                </Button>
                <Button
                    onClick={() => handleDeleteBaseStation(state.id)}
                    color="primary"
                    type="submit"
                    disabled={state.loading}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align || 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function ViewNotifications() {
    const classes = useStyles()
    const history = useHistory()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: true,
        resolved: false,
        notifications: [],
    })
    const [stateFile, setStateFile] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: false,
        resolved: false,
        message: null,
        file: null,
        typeMessage: null,
        visibleMessage: false,
    })
    const [stateSearch, setStateSearch] = useReducer((s, a) => ({ ...s, ...a }), {
        input: '',
        loading: false,
    })
    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('calories')
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [visibleDialogCsv, setVisibleDialogCsv] = useState(false)
    const [visibleDialogCsvFormat, setVisibleDialogCsvFormat] = useState(false)
    const [stateDialogDelete, setStateDialogDelete] = useReducer((s, a) => ({ ...s, ...a }), {
        loading: false,
        visible: false,
        id: null,
    })

    useEffect(() => {
        setState({            
            loading: false,
            resolved: true
        });
        
        fetchNotifications()
            .then(response => {
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    notifications: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
        
    }, [])

    
    const fetchNotifications = async (search = '') => {
        try {
            const { data: notifications } = await get(
                `/sendNotifications?`,
            )
            
            return notifications
        } catch (e) {
            throw new Error(e)
        }
    }
    

    const deleteBaseStation = async id => {
        try {
            const { data: baseStation } = await del(
                `/notifications/${id}?code=xRgHBbduEaMjR3pW/FANmp34eFA0UldxIRJf9FAEFPb6Kbp/QLaMSQ==`,
            )

            return baseStation
        } catch (e) {
            throw new Error(e)
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = state.devices.map(n => n.name)
            setSelected(newSelecteds)
            return
        }
        setSelected([])
    }

    const handleClickRow = id => {
        history.push(`/notifications/${id}`)
    }

    const handleClickResults = id => {
        history.push(`/notifications/${id}/results`)
    }

    const handleClickDelete = id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: true,
            id,
        })
    }

    const handleDeleteBaseStation = async id => {
        setStateDialogDelete({
            ...stateDialogDelete,
            loading: true,
        })
        deleteBaseStation(id)
            .then(() => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                    visible: false,
                })
                setStateFile({
                    ...stateFile,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base station has been deleted successfully.`,
                })
                fetchNotifications()
                    .then(bs => {
                        setState({
                            ...state,
                            loading: false,
                            resolved: true,
                            notifications: bs,
                        })
                    })
                    .catch(e => {
                        setState({
                            ...state,
                            loading: false,
                            error: e,
                        })
                    })
            })
            .catch(error => {
                setStateDialogDelete({
                    ...stateDialogDelete,
                    loading: false,
                })
            })
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const handleCloseDialogCsv = () => {
        setVisibleDialogCsv(false)
    }

    const handleCloseDialogCsvFormat = () => {
        setVisibleDialogCsvFormat(false)
    }

    const handleCloseDialogDelete = () => {
        setStateDialogDelete({
            ...stateDialogDelete,
            visible: false,
            id: null,
        })
    }

    const handleChangeFile = files => {
        if (files.length > 0) {
            setStateFile({
                ...stateFile,
                file: files[0],
            })
        } else {
            setStateFile({
                ...stateFile,
                file: null,
            })
        }
    }

    const handleCloseMessageReport = () => {
        setStateFile({
            ...stateFile,
            visibleMessage: false,
        })
    }

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            filternotifications(stateSearch.input)
        }
    }

    const filternotifications = search => {
        setStateSearch({
            ...state,
            loading: true,
        })
        fetchNotifications(search)
            .then(response => {
                setStateSearch({
                    ...state,
                    loading: false,
                })
                setState({
                    ...state,
                    loading: false,
                    resolved: true,
                    notifications: response,
                })
            })
            .catch(e => {
                setState({
                    ...state,
                    loading: false,
                    error: e,
                })
            })
    }

    const uploadFile = () => {
        setStateFile({
            ...stateFile,
            loading: true,
        })
        postFormData(
            '/notifications-csv?code=yo65LJxxz8mG3kgeXvHg6rMkLMgpIxzBmBOjB2blamXaKpIhM9FSzQ%3D%3D',
            stateFile.file,
        )
            .then(() => {
                setVisibleDialogCsv(false)
                setStateFile({
                    ...stateFile,
                    loading: false,
                    resolved: true,
                    visibleMessage: true,
                    typeMessage: 'success',
                    message: `Base stations has been saved successfully.`,
                })
                fetchNotifications()
                    .then(newnotifications => {
                        setState({
                            ...state,
                            loading: false,
                            resolved: true,
                            notifications: newnotifications,
                        })
                    })
                    .catch(e => {
                        setState({
                            ...state,
                            loading: false,
                            error: e,
                        })
                    })
            })
            .catch(error => {
                setStateFile({
                    ...stateFile,
                    loading: false,
                    resolved: false,
                    error,
                    visibleMessage: true,
                    typeMessage: 'error',
                    message: `An error has ocurred. Please, try again.`,
                })
            })
    }

    // render variables
    const rows = state.notifications
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

    // render
    if (!state.resolved)
        return (
            <Backdrop className={classes.backdrop} open={state.loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    return (
        <Grid container spacing={0}>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        style={{ borderBottom: '1px solid' }}
                    >
                        <h2>Incidents</h2>
                    </Grid>
                    <Grid
                        xs={11}
                        sm={11}
                        md={11}
                        lg={11}
                        xl={11}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        style={{ marginTop: '1em' }}
                    >
                        <Grid item xs={11} sm={11} md={11} lg={6} xl={4}>
                            <TextField
                                fullWidth
                                size="large"
                                id="standard-basic"
                                label="Search by Name"
                                onChange={e =>
                                    setStateSearch({ ...stateSearch, input: e.target.value })
                                }
                                onKeyDown={handleKeyPress}
                                disabled={stateSearch.loading}
                            />
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={2} xl={2}>
                            {stateSearch.loading ? (
                                <CircularProgress color="inherit" />
                            ) : (
                                <IconButton
                                    type="submit"
                                    className={classes.iconButton}
                                    aria-label="search"
                                    onClick={() => filternotifications(stateSearch.input)}
                                >
                                    <SearchIcon />
                                </IconButton>
                            )}
                        </Grid>
                        <TableContainer>
                            <Table
                                className={classes.table}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                                aria-label="enhanced table"
                            >
                                <EnhancedTableHead
                                    classes={classes}
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                />
                                <TableBody>
                                    {stableSort(rows, getComparator(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, index) => {
                                            return (
                                                <TableRow tabIndex={-1} key={row.id}>
                                                    <TableCell>{row.deviceId || '-'}</TableCell>
                                                    <TableCell>{row.model || '-'}</TableCell>
                                                    <TableCell>{row.brand || '-'}</TableCell>
                                                    <TableCell>{row.parameter || '-'}</TableCell>
                                                    <TableCell>{row.createdAt || '-'}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            className={classes.root}
                            rowsPerPageOptions={[]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Grid>
                </Grid>
            </Grid>
            
            <DialogCSV
                classes={classes}
                handleCloseDialogCsv={handleCloseDialogCsv}
                stateFile={stateFile}
                handleChangeFile={handleChangeFile}
                uploadFile={uploadFile}
                visibleDialogCsv={visibleDialogCsv}
                setVisibleDialogCsvFormat={setVisibleDialogCsvFormat}
            />
            <DialogCSVFormat
                classes={classes}
                handleCloseDialogCsvFormat={handleCloseDialogCsvFormat}
                stateFile={stateFile}
                handleChangeFile={handleChangeFile}
                uploadFile={uploadFile}
                visibleDialogCsvFormat={visibleDialogCsvFormat}
            />
            <DialogDelete
                classes={classes}
                handleCloseDialogDelete={handleCloseDialogDelete}
                state={stateDialogDelete}
                handleDeleteBaseStation={handleDeleteBaseStation}
                visible={stateDialogDelete.visible}
            />
            <AlertWrapper
                description={stateFile.message}
                handleClose={handleCloseMessageReport}
                type={stateFile.typeMessage}
                visible={stateFile.visibleMessage}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: 10,
                    right: 30,
                }}
            >
            </div>
        </Grid>
    )
}

export default ViewNotifications
